import {notification} from "@ui";
import {theme} from "antd";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, PrimaryButton, SecondaryButton} from "@/components/Button";
import useCreateTransfer from "../../hooks/wallet/useCreateTransfer";
import {useBalanceStore} from "../../store/useBalance.store";
import {useCurrentAndSelectedContactStore} from "../../store/Wallet/useTransfer.store";
import CustomSteps from "../CustomSteps";
import TransferAmount from "./components/TransferAmount";
import TransferConfirm from "./components/TransferConfirm";
import TransferUserId from "./components/TransferUserId";

const TransferSteps = () => {
  const {token} = theme.useToken();
  // const {transferAmount: transferAmount, setTransferAmount: setTransferAmount} = useCurrentAndSelectedContactStore();
  const [transferAmount, setTransferAmount] = useState(0);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const {requestSendMoney, isPending, isError, isSuccess} = useCreateTransfer();
  const {handleTransferModal} = useBalanceStore();
  const {current, setCurrent} = useCurrentAndSelectedContactStore();
  const {selectedContact, setSelectedContact} = useCurrentAndSelectedContactStore();

  const {t} = useTranslation();

  const isMobile = window.innerWidth <= 768;

  const steps = [
    {
      title: t("transferStepsBeneficiary"),
      content: (
        <TransferUserId
          selectedContact={selectedContact}
          setSelectedContact={setSelectedContact}
          setIsNextDisabled={setIsNextDisabled}
        />
      ),
    },
    {
      title: t("transferStepsAmount"),
      content: (
        <TransferAmount
          transferAmount={transferAmount}
          setTransferAmount={setTransferAmount}
          setIsNextDisabled={setIsNextDisabled}
        />
      ),
    },
    {
      title: t("transferStepsTransfer"),
      content: (
        <TransferConfirm
          transferContact={selectedContact}
          transferAmount={transferAmount}
        />
      ),
    },
  ];

  const resetTransferState = () => {
    setTransferAmount(0);
    setSelectedContact({});
    setCurrent(0);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
    // If returning to step 0 and a contact is selected, enable Next button
    if (current - 1 === 0 && selectedContact && selectedContact.id) {
      setIsNextDisabled(false);
    }
  };

  const handleConfirm = () => {
    requestSendMoney({
      amount: Number(transferAmount),
      receiver_id: selectedContact.id,
    });
    resetTransferState();
    handleTransferModal();
  };

  useEffect(() => {
    if (isError) {
      notification.error({
        message: t("transferStepsError"),
        description: t("transferStepsErrorDesc_1"),
      });
    } else if (isSuccess) {
      notification.success({
        message: t("transferStepsSuccess"),
        description: t("transferStepsSuccessMessage"),
      });
    }
  }, [isError, isSuccess]);

  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: "var(--modal-bg)",
    borderRadius: token.borderRadiusLG,
    marginTop: 16,
    padding: 24,
  };
  return (
    <div
      style={{
        minWidth: "100%",
        margin: "0 auto",
        paddingTop: "30px",
      }}
    >
      <CustomSteps
        steps={steps}
        current={current}
      />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 50,
        }}
      >
        {/* Step 0: Next, Cancel */}
        {current === 0 && (
          <div style={{display: "flex", justifyContent: "center", gap: "26px"}}>
            <PrimaryButton
              onClick={next}
              disabled={isNextDisabled}
            >
              {t("transferStepsNext")}
            </PrimaryButton>
            <Button
              variant={isMobile ? "cancel-secondary" : "secondary"}
              onClick={() => {
                resetTransferState();
                handleTransferModal();
              }}
            >
              {t("transferStepsCancel")}
            </Button>
          </div>
        )}
        {/* Step 1: Next, Back, Cancel */}
        {current === 1 && (
          <>
            <PrimaryButton
              onClick={next}
              disabled={isNextDisabled}
            >
              {t("transferStepsNext")}
            </PrimaryButton>
            <SecondaryButton
              style={{margin: "0 8px"}}
              onClick={prev}
            >
              {t("transferStepsBack")}
            </SecondaryButton>
            <Button
              variant={isMobile ? "cancel-mobile" : "secondary"}
              style={{margin: "0 8px", float: "right"}}
              onClick={() => {
                resetTransferState();
                handleTransferModal();
              }}
            >
              {isMobile ? "X" : t("transferStepsCancel")}
            </Button>
          </>
        )}
        {/* Step 2: Confirm, Cancel */}
        {current === 2 && (
          <>
            <PrimaryButton
              disabled={isPending}
              onClick={handleConfirm}
            >
              {t("transferStepsConfirm")}
            </PrimaryButton>
            <SecondaryButton
              style={{margin: "0 8px"}}
              onClick={prev}
            >
              {t("transferStepsBack")}
            </SecondaryButton>
            <Button
              variant={isMobile ? "cancel-mobile" : "secondary"}
              style={{margin: "0 8px", float: "right"}}
              onClick={() => {
                resetTransferState();
                handleTransferModal();
              }}
            >
              {isMobile ? "X" : t("transferStepsCancel")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
export default TransferSteps;
